import { StrictMode } from 'react';
import * as ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';

import App from './app/app';
import { Provider } from 'react-redux';
import { store } from './app/redux/store';
import { MediaPreviewProvider } from './app/components/PreviewAvatarMedia/MediaPreviewProvider';
import YandexMetrika from './app/components/YandexMetrika/YandexMetrika';

// import { login } from './app/utils';

// const Login = () => {
//   const [pass, setPass] = useState('');
//   const [name, setName] = useState('');
//   const navigate = useNavigate();
//   const onClick = () => {
//     login(name, pass).then((resp) => resp.ok && navigate('/avatar'));
//   };
//   return (
//     <div>
//       <input value={name} onChange={(e) => setName(e.target.value)} />
//       <input
//         type="password"
//         value={pass}
//         onChange={(e) => setPass(e.target.value)}
//       />
//       <button onClick={() => onClick()}>log in</button>
//     </div>
//   );
// };

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <StrictMode>
    <Provider store={store}>
      <BrowserRouter>
        <MediaPreviewProvider>
          <YandexMetrika />
          <App />
        </MediaPreviewProvider>
      </BrowserRouter>
    </Provider>
  </StrictMode>
);
